var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSurprised(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 578.66 771.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#0c0c0c;stroke-width:4px;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-16,.cls-17,.cls-2,.cls-20,.cls-23,.cls-24,.cls-25,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-1{fill:url(#Degradado_sin_nombre_37);}.cls-2{fill:url(#Degradado_sin_nombre_37-2);}.cls-3{fill:url(#Degradado_sin_nombre_37-3);}.cls-4{fill:url(#Degradado_sin_nombre_37-4);}.cls-5{fill:url(#Degradado_sin_nombre_37-5);}.cls-6{fill:url(#Degradado_sin_nombre_37-6);}.cls-7{fill:url(#Degradado_sin_nombre_37-7);}.cls-8{fill:url(#Degradado_sin_nombre_37-8);}.cls-9{fill:url(#Degradado_sin_nombre_37-9);}.cls-10{fill:url(#Degradado_sin_nombre_37-10);}.cls-11{fill:url(#Degradado_sin_nombre_37-11);}.cls-12{fill:url(#Degradado_sin_nombre_37-12);}.cls-13{fill:url(#Degradado_sin_nombre_37-13);}.cls-14{fill:#a81616;}.cls-15{fill:#fff;}.cls-16,.cls-23{fill:none;}.cls-16,.cls-17,.cls-20,.cls-23,.cls-24,.cls-25{stroke:#161616;}.cls-16,.cls-17,.cls-20{stroke-width:5px;}.cls-17{fill:#e2e2e2;}.cls-18{fill:#0f0f0f;}.cls-19{fill:#bc0000;}.cls-20{fill:#f9f9f9;}.cls-21{fill:#161616;}.cls-22{fill:#bababa;}.cls-23,.cls-24,.cls-25{stroke-width:3px;}.cls-24{fill:#ff7878;}.cls-25{fill:#a1e9ff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37",
    x1: 449.62,
    y1: 25.5,
    x2: 449.62,
    y2: 109.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff9e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff3bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ffeea2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffea8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ffe883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe77f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-2",
    x1: 4479.23,
    y1: 137.2,
    x2: 4628.68,
    y2: 137.2,
    gradientTransform: "matrix(-1, -0.01, -0.01, 1, 4645.97, 10.64)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-3",
    x1: 167.25,
    y1: 15.26,
    x2: 167.25,
    y2: 99.67,
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-4",
    x1: 4032.33,
    y1: -107.17,
    x2: 4195.39,
    y2: -107.17,
    gradientTransform: "matrix(-0.99, -0.3, 0.31, -1.01, 4417.92, 1194.06)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-5",
    x1: 276.58,
    y1: -450,
    x2: 426.03,
    y2: -450,
    gradientTransform: "matrix(0.96, -0.27, 0.27, 0.96, -133.36, 651.81)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-6",
    x1: 771.47,
    y1: -391.51,
    x2: 737.22,
    y2: -271.5,
    gradientTransform: "matrix(0.96, -0.27, 0.27, 0.96, -133.36, 651.81)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-7",
    x1: 2889.2,
    y1: -1272.71,
    x2: 3038.65,
    y2: -1272.71,
    gradientTransform: "translate(1491.07 3078.21) rotate(-90.32)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-8",
    x1: 1783.9,
    y1: 2998.82,
    x2: 1933.35,
    y2: 2998.82,
    gradientTransform: "matrix(-0.11, 0.99, -0.99, -0.11, 3342.57, -1369.68)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-9",
    x1: 214.28,
    y1: 100.21,
    x2: 371.93,
    y2: 100.21,
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-10",
    x1: 376.68,
    y1: 1.54,
    x2: 374.65,
    y2: 103.92,
    gradientTransform: "translate(-4.69 45.91) rotate(-1.14)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-11",
    x1: 262.31,
    y1: 63.13,
    x2: 262.31,
    y2: 147.54,
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-12",
    x1: 449.62,
    y1: 67.7,
    x2: 449.62,
    y2: 152.11,
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-13",
    x1: 284.2,
    y1: 134.26,
    x2: 417.64,
    y2: 134.26,
    xlinkHref: "#Degradado_sin_nombre_37"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pochoclo sorprendido") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pochoclos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.9,106.17s20.42-7.66,10.85-37c0,0,3.19-26.17,32.55-17.88,0,0,30-53,51.71-7,0,0,48.51,4.47,36.38,34.47C514.39,78.72,536.09,122.77,382.9,106.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142,114.47s49-13.55,6-51.27c0,0-41.86-29.15-40.5,16.08,0,0-43.26-70.11-75-10.57,0,0-36.56,48.51-.71,67.21,0,0,18.73,20.36,39.72.42,0,0,50.36,33.52,68.3,12.32C139.77,148.66,148.44,137.75,142,114.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.53,95.93s20.43-7.66,10.85-37c0,0,3.19-26.17,32.56-17.87,0,0,30-53,51.7-7,0,0,48.51,4.47,36.38,34.47C232,68.48,253.73,112.52,100.53,95.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M375.94,95.34c-8.2,16.72-52.06,30.54-77.06.71,0,0-70.18,35.64-74.14-39.11,0,0,12.57-67,64.06-23,0,0,48.89-65.8,70.26-8.4,0,0,58.95-10.34,42.91,27.14C398.05,61.8,383.56,79.77,375.94,95.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.4,150s-50.86-.1-19.38-47.84c0,0,32.66-39.19,43.31,4.79,0,0,23.18-79.05,69.58-30,0,0,48.08,37.11,18.45,64.63,0,0-12.68,24.59-38.19,10.9,0,0-39.71,45.65-62.62,29.95C46.55,182.35,35.31,174.12,35.4,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455.05,152.69s-50.86-.1-19.38-47.84c0,0,32.66-39.19,43.31,4.79,0,0,23.18-79,69.58-30,0,0,48.08,37.11,18.45,64.63,0,0-12.68,24.59-38.19,10.9,0,0-39.71,45.65-62.62,30C466.2,185.09,455,176.86,455.05,152.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M215.9,172.62s-13.78,48.95-51.29,5.78c0,0-29-42,16.27-40.42,0,0-69.9-43.6-10.19-75.1,0,0,48.67-36.32,67.2-.37,0,0,20.27,18.83.23,39.72,0,0,33.27,50.52,12,68.36C250.11,170.59,239.16,179.21,215.9,172.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M155.18,107.65s19.16-47.11,51.62,0c0,0,24.08,45-20.69,38.35,0,0,64.59,51.14,1.74,75.77,0,0-52.43,30.65-66.83-7.14,0,0-18-21,4.22-39.49,0,0-27.42-53.93-4.28-69.28C121,105.84,132.8,98.51,155.18,107.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M214.28,104.14s40.9-8.66,51.49-33.94c0,0,19.6-58.78,58.78-12.57a20.17,20.17,0,0,0,11,6.71C351,67.71,386.67,79.77,365.26,117c0,0-23.76,46.81-72.16,43.3C293.1,160.32,221.3,163.83,214.28,104.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M307.84,139.85s-51.31-15,9.07-66.31c0,0,10.7,8.7,43-27.35a18.41,18.41,0,0,1,21.61-4.43c9.2,4.43,20.52,12,24.94,23.39,0,0,49.84-11.37,49.89,38.69,0,0,1.73,39.64-37,38.52,0,0-9-24.38-37.25-21S326.33,119.64,307.84,139.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M195.59,143.8s20.43-7.66,10.85-37c0,0,3.19-26.18,32.56-17.88,0,0,30-53,51.7-7,0,0,48.51,4.47,36.38,34.47C327.08,116.35,348.79,160.39,195.59,143.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M382.9,148.37s20.42-7.66,10.85-37c0,0,3.19-26.17,32.55-17.87,0,0,30-53,51.71-7,0,0,48.51,4.46,36.38,34.47C514.39,120.93,536.09,165,382.9,148.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M284.2,172.73s20.42-7.66,10.85-37c0,0,3.19-26.17,32.55-17.87,0,0,30-53,51.7-7,0,0,48.52,4.47,36.39,34.47C415.69,145.28,437.39,189.32,284.2,172.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rojo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M5.87,147.91S36.69,99,85.7,145l90.09,549.54H129.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M168.45,145.46s29.12-49.42,82.49,0l18.42,177-77.39-1Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "269.36 322.46 308.47 697.04 235.38 697.04 191.97 321.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M337.82,144.5s31.44-49.11,81.48,1l13.79,252.09-72.9,1.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "360.19 398.94 383.08 697.04 449.62 697.04 433.09 397.55 360.19 398.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M498.06,146.3s26.49-52.5,68.95-2.06l-63.72,392Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "blanco"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M127,398.53,87.17,145s33.54-48.39,80.37-.48L201,397.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "225.74 613.03 235.38 697.04 178.43 697.04 126.98 398.53 201 397.55 219.15 533.38 225.74 613.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M250.94,145.46s30.16-52.59,86.88,1.17l22.37,252.31-86.11-31.15Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "273.78 364.8 308.47 697.04 383.08 697.04 360.19 398.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M433.15,398.53,449.62,697h28l25.64-148L498.06,146.3c-48.93-52.61-78.76,1.24-78.76,1.24l9.76,174.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lineas"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2.69,147.46,128.47,697H477.56L567,144.24s-31.92-49.87-69,2.06c0,0-43.13-53.33-78.76,1.24,0,0-44.23-55.62-81.48-.91,0,0-49.9-55.06-86.92-.9,0,0-45.36-52.76-82.46-.27,0,0-45.56-50.74-80.63,0C87.72,145.46,41.53,94.72,2.69,147.46Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 126.88,
    y1: 398.53,
    x2: 178.34,
    y2: 697.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 191.97,
    y1: 321.5,
    x2: 220.85,
    y2: 547.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 273.69,
    y1: 364.8,
    x2: 290.88,
    y2: 529.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 360.09,
    y1: 397.55,
    x2: 382.99,
    y2: 697.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 433,
    y1: 397.55,
    x2: 449.52,
    y2: 697.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 419.21,
    y1: 145.46,
    x2: 433.09,
    y2: 397.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 337.73,
    y1: 144.5,
    x2: 360.19,
    y2: 398.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 250.84,
    y1: 145.46,
    x2: 273.78,
    y2: 364.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 168.35,
    y1: 145.46,
    x2: 191.87,
    y2: 321.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 87.08,
    y1: 144.98,
    x2: 126.88,
    y2: 398.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 289.75,
    y1: 518.69,
    x2: 308.37,
    y2: 697.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 225.4,
    y1: 602.34,
    x2: 235.29,
    y2: 697.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 497.97,
    y1: 146.3,
    x2: 503.07,
    y2: 539.37
  })), /*#__PURE__*/React.createElement("g", {
    id: "Boca"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M271,514.09a97.47,97.47,0,0,0-97.46,97.47H362a6.32,6.32,0,0,0,6.26-6.81A97.47,97.47,0,0,0,271,514.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M207.89,581.8c.1-9.35,19.13-13.44,40.81-13.44s40.63,4.53,40.78,13.88c.27,16.94.27,16.93-39.26,16.93S207.71,598.74,207.89,581.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ojos_llora_pop",
    "data-name": "Ojos llora pop"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 180.11,
    cy: 322.46,
    rx: 50.07,
    ry: 42.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 186.58,
    cy: 343.84,
    rx: 14.42,
    ry: 12.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 391.19,
    cy: 321.5,
    rx: 50.07,
    ry: 42.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 387.42,
    cy: 342.88,
    rx: 14.42,
    ry: 12.19
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lentes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2.44,622.47l28.8-60.4a4.09,4.09,0,0,1,5.45-1.93L333.53,701.71a4.09,4.09,0,0,1,1.93,5.45l-28.8,60.4a4.1,4.1,0,0,1-5.45,1.93l-106.91-51a4.07,4.07,0,0,1-2.29-3.19l-4.21-34.1a4.1,4.1,0,0,0-2.3-3.19l-37.68-18a4.1,4.1,0,0,0-4,.28l-28.08,18.51a4.1,4.1,0,0,1-4,.28L4.37,627.92A4.09,4.09,0,0,1,2.44,622.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2.93,621.43l28.31-59.36a4.09,4.09,0,0,1,5.45-1.93L333.53,701.71a4.09,4.09,0,0,1,1.93,5.45l-28.39,59.52a5.06,5.06,0,0,1-6.74,2.39l-106-50.57a4.07,4.07,0,0,1-2.29-3.19l-4.21-34.1a4.1,4.1,0,0,0-2.3-3.19l-37.68-18a4.1,4.1,0,0,0-4,.28l-28.08,18.51a4.1,4.1,0,0,1-4,.28L5.41,628.41A5.25,5.25,0,0,1,2.93,621.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M20.12,620l19.39-40.66A4.09,4.09,0,0,1,45,577.43l98.1,46.79a4.08,4.08,0,0,1,1.93,5.44l-9.49,19.89a4,4,0,0,1-1.71,1.82l-24.73,13.7a4.08,4.08,0,0,1-3.74.11L22.05,625.47A4.09,4.09,0,0,1,20.12,620Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M297.39,751.92,317,710.81a4.09,4.09,0,0,0-1.93-5.45l-100.9-48.12a4.09,4.09,0,0,0-5.45,1.93l-9.59,20.1a4.17,4.17,0,0,0-.33,2.51L204,710.06A4.09,4.09,0,0,0,206.3,713L292,753.85A4.08,4.08,0,0,0,297.39,751.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSurprised);
export default __webpack_public_path__ + "static/media/LogoSurprised.50417ed70f1d5ef90249e8457b9ea15f.svg";
export { ForwardRef as ReactComponent };